import React from "react";
import Layout from "@/components/Layout";
import { ScrollFade, HeroStaggerText } from "@/lib/animations";

export default function PrivacyPolicy() {
  return (
    <Layout>
      <section className="bg-[#163A2F] text-[#F8F6F0] grain relative pt-20 pb-16 md:pt-28 md:pb-20 overflow-hidden">
        <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24">
          <div className="overline text-[#C9A227]">Legal</div>
          <HeroStaggerText
            text="Privacy Policy"
            className="mt-3 text-4xl md:text-6xl font-extralight tracking-tight"
          />
          <p className="mt-4 text-[#F8F6F0]/70 font-light text-sm tracking-wider">Last updated: 10 February 2026</p>
        </div>
      </section>

      <section className="bg-[#F8F6F0] py-16 md:py-20" data-testid="privacy-policy-page">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-[#163A2F] font-light leading-relaxed space-y-8">
          <ScrollFade>
            <p>
              Norbu Collection ("we", "our", "us") respects your privacy. This Privacy Policy explains how we collect, use, store and protect the personal information you share with us when you visit <a href="https://norbu.in" className="text-[#C9A227] underline">norbu.in</a> or purchase from us.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">1. Information we collect</h2>
            <ul className="mt-3 list-disc pl-5 space-y-2 text-[#163A2F]/85">
              <li><strong>Identity &amp; contact:</strong> name, email, phone, shipping and billing address.</li>
              <li><strong>Order details:</strong> items purchased, size, colour, order value, payment method.</li>
              <li><strong>Payment data:</strong> card/UPI details are collected and processed directly by our payment partner PayU. We do not store full card numbers or CVVs on our servers.</li>
              <li><strong>Device &amp; usage:</strong> IP address, browser type, pages visited, cookies and similar technologies to improve the site.</li>
            </ul>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">2. How we use your information</h2>
            <ul className="mt-3 list-disc pl-5 space-y-2 text-[#163A2F]/85">
              <li>To process orders, payments and ship your purchases.</li>
              <li>To send transactional emails (order confirmation, dispatch, tracking) via Resend.</li>
              <li>To provide customer support and respond to your queries.</li>
              <li>To send marketing updates about new drops — only if you have opted in. You can unsubscribe anytime.</li>
              <li>To comply with Indian legal obligations, prevent fraud and resolve disputes.</li>
            </ul>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">3. Sharing with third parties</h2>
            <p className="mt-3 text-[#163A2F]/85">We share only the minimum data required to run the store:</p>
            <ul className="mt-3 list-disc pl-5 space-y-2 text-[#163A2F]/85">
              <li><strong>PayU</strong> — to process payments securely.</li>
              <li><strong>Shiprocket &amp; delivery partners</strong> — to deliver your order and generate tracking.</li>
              <li><strong>Resend</strong> — to send transactional emails.</li>
            </ul>
            <p className="mt-3 text-[#163A2F]/85">We do not sell your personal information to anyone.</p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">4. Cookies</h2>
            <p className="mt-3 text-[#163A2F]/85">
              We use essential cookies to keep your cart and session active, and basic analytics cookies to understand how customers use the site. You can disable cookies in your browser, but parts of the site may not function.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">5. Data security</h2>
            <p className="mt-3 text-[#163A2F]/85">
              All payments run over HTTPS and are tokenised by PayU. Passwords on your account are hashed. We retain order data for the period required by Indian tax and accounting law.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">6. Your rights</h2>
            <p className="mt-3 text-[#163A2F]/85">
              You can request access to, correction of, or deletion of your personal data by writing to <a href="mailto:support.norbucollection@gmail.com" className="text-[#C9A227] underline">support.norbucollection@gmail.com</a>. We will respond within 30 days.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">7. Contact</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Norbu Collection<br />
              New Delhi, India<br />
              Email: <a href="mailto:support.norbucollection@gmail.com" className="text-[#C9A227] underline">support.norbucollection@gmail.com</a><br />
              Phone: +91 95609 95329
            </p>
          </ScrollFade>
        </div>
      </section>
    </Layout>
  );
}
